import Vue from "vue";
import VueScrollto from "vue-scrollto";

Vue.use(VueScrollto, {
  duration: 500
});
